import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SpinerComponent } from './shared/spiner/spiner.component';
import { SpinnerService } from '../services/spinner/spinner.service';
import { ParametroCarga } from '../models/spinner/parametroCarga.class';


@Component({
  selector: 'app-contenedor',
  templateUrl: './contenedor.component.html',
  styleUrls: ['./contenedor.component.scss']
})
export class ContenedorComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  blockTemplate = SpinerComponent;
  menu: any;

  constructor(private spinnerService: SpinnerService) {
  }

  ngOnInit() {
    this.suscribirSpinner();
  }


  suscribirSpinner() {
    this.spinnerService.status.subscribe((val: ParametroCarga) => {
      if (val.activo === true) {
        this.blockUI.start(val.mensaje);
      } else {
        this.blockUI.stop();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/contenedor.component.ts